import {createActionGroup, emptyProps} from '@ngrx/store';
import {ListData} from '@aviary/store/common/common.types';
import {BALANCE_FEATURE_KEY, MakeAPaymentValue, PatronBalanceTransaction, PaymentConfirmationValue, SquareAppDetails} from './balance.types';

export const BalanceActions = createActionGroup({
  source: BALANCE_FEATURE_KEY,
  events: {
    'Load Balance Transactions': emptyProps(),
    'Load Balance Transactions Success': (listData: ListData<PatronBalanceTransaction>) => ({listData}),
    'Load Balance Transactions Failure': (error: unknown) => ({error}),
    'Toggle Include All Balance Transactions': emptyProps(),

    'Load Square App Details': emptyProps(),
    'Load Square App Details Success': (squareAppDetails: SquareAppDetails) => ({squareAppDetails}),
    'Load Square App Details Failure': (error: unknown) => ({error}),
    'Show Make A Payment': emptyProps(),
    'Submit Make A Payment': (value: MakeAPaymentValue) => ({value}),
    'Submit Make A Payment Success': emptyProps(),
    'Submit Make A Payment Failure': (error: unknown) => ({error}),
    'Show Payment Confirmation': (value: PaymentConfirmationValue) => ({value}),

    'Show Make A Payment For Dependent': emptyProps(),
    'Submit Make A Payment For Dependent': (value: MakeAPaymentValue, dependentPatronId: number) => ({value, dependentPatronId}),
    'Submit Make A Payment For Dependent Success': emptyProps(),
    'Submit Make A Payment For Dependent Failure': (error: unknown) => ({error}),
  }
});
